export const MEDIA_BREAKPOINT_MG = 1920
export const MEDIA_BREAKPOINT_XL = 1200
// export const MEDIA_BREAKPOINT_LG = 992
export const MEDIA_BREAKPOINT_LG = 360
// export const MEDIA_BREAKPOINT_MD = 640
export const MEDIA_BREAKPOINT_MD = 360
// export const MEDIA_BREAKPOINT_SM = 480
export const MEDIA_BREAKPOINT_SM = 360